<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="mb-4">Boas vindas à Easytick!</h2>

          <p>Estamos à disposição para atendê-lo e tornar seu evento ou bar mais simples.</p>

          <p>Abaixo nossos contatos:</p>

          <ul style="list-style-type: none;" class="px-0 mb-3">
            <li class="pb-2">☎️ Gabriel Spuri - (35) 9 9835-1273</li>
            <li class="pb-2">☎️ Gilson Rocha - (35) 9 9870-0887</li>
          </ul>

          <ul style="list-style-type: none;" class="px-0">
            <li class="pb-2">📱 <a target="_blank" href="https://api.whatsapp.com/send?phone=5535998351273&text=Ol%C3%A1%2C%20gostaria%20de%20falar%20sobre%20a%20Easytick.">Abrir WhatsApp com Gabriel Spuri</a></li>
            <li class="pb-2">📱 <a target="_blank" href="https://api.whatsapp.com/send?phone=5535998700887&text=Ol%C3%A1%2C%20gostaria%20de%20falar%20sobre%20a%20Easytick.">Abrir WhatsApp com Gilson Rocha</a></li>
          </ul>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'OrganizerOverview',
  data () {
    return {

    }
  }
}
</script>
